export const API_URL = "https://pf2-t5kvd46e4a-du.a.run.app/infer/";
export default API_URL;
